import { ComponentType } from "react";

import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { leadHistoryReducer } from "../../../redux/slices/leadHistory";
import {
    getLeadHistoryAsync,
    retryLeadHistoryAsync,
} from "../../../redux/slices/leadHistory/leadHistory.asyncActions";
import { clearLeadHistory } from "../../../redux/slices/leadHistory/leadHistory.slice";
import LeadHistoryPage from "./LeadHistoryPage.layout";
import type {
    LeadHistoryPageDispatchProps,
    LeadHistoryPageOwnProps,
    LeadHistoryPageStateProps,
} from "./LeadHistoryPage.types";

const mapStateToProps = (state: any): LeadHistoryPageStateProps => ({
    leads: state[leadHistoryReducer].leads,
    pagination: state[leadHistoryReducer].pagination,
    isLeadHistoryLoading: state[leadHistoryReducer].isLeadHistoryLoading,
    leadHistoryError: state[leadHistoryReducer].leadHistoryError,
    isRetryLoading: state[leadHistoryReducer].isRetryLoading,
    retryError: state[leadHistoryReducer].retryError,
    retryingStatId: state[leadHistoryReducer].retryingStatId,
});

const mapDispatchToProps = (dispatch: any): LeadHistoryPageDispatchProps => ({
    dispatchGetLeadHistory: (payload) => dispatch(getLeadHistoryAsync(payload)),
    dispatchRetryLeadHistory: (payload) =>
        dispatch(retryLeadHistoryAsync(payload)),
    dispatchClearLeadHistory: () => dispatch(clearLeadHistory()),
});

const decorate = compose<ComponentType<LeadHistoryPageOwnProps>>(
    connect(mapStateToProps, mapDispatchToProps),
);

export default decorate(LeadHistoryPage);
